import React from "react";
import { CustomTitleLabel } from "./CustomBaseComponments";
import InputFieldControl from "components/base/InputFieldControl";
import './GeneralPurchasePerMin.scss';

const GeneralPurchasePerMin = ({
  containerClassName,
  title,
  minSpendingName,
  minQuantityName,
}) => (
  <div className={`general-purchase-per-min-container ${containerClassName}`}>
    <CustomTitleLabel title={title} className='general-purchase-per-transaction-title' />
    <InputFieldControl
      customTitleClass='general-purchase-min-spending-title'
      name={minSpendingName}
      title='Minimum spending (optional)'
      useDefaultFieldName
      type='number'
      per='HK$'
      className='coupon-campaign-section-input'
    />
    <InputFieldControl
      customTitleClass='general-purchase-min-quantity-title'
      name={minQuantityName}
      title='Minimum quantity (optional)'
      useDefaultFieldName
      type='number'
      className='coupon-campaign-section-input'
      unit='Items'
    />
  </div>
)

export default GeneralPurchasePerMin;
